import ExcelJS from "exceljs";
import TGButton from "src/components/ui/TGButton";
import { DownloadIcon } from "src/components/ui-icons/upload";
import { mode } from "src/constants";
import { siteUrl } from "src/api/config";

interface ExportDataGosProps {
  data: any[];
  isExportLic?: boolean;
  isTestEnvironment?: boolean;
}

const ExportDataGos: React.FC<ExportDataGosProps> = ({
  data,
  isExportLic,
  isTestEnvironment = false,
}) => {
  const exportExcelFile = async () => {
    try {
      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet(
        isExportLic ? "Лицензии" : "Предписания"
      );
      const baseUrl = siteUrl + "/dashboard/4";

      function toUTCDate(dateInput?: string | number | Date): Date | "" {
        if (!dateInput) return "";
        const d = new Date(dateInput);
        return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
      }

      function createHyperlink(
        id: string | number,
        text: string,
        isLicense: boolean = false
      ): any {
        const url = isLicense
          ? `${baseUrl}/licenses?licenseCard=${id}`
          : `${baseUrl}?prescriptionCard=${id}`;

        return {
          text: text,
          hyperlink: url,
          tooltip: `Перейти к карточке: ${text}`,
        };
      }

      if (isExportLic) {
        sheet.columns = [
          { header: "Номер документа", key: "documentNumber", width: 20 },
          { header: "Статус документа", key: "status", width: 15 },
          { header: "Локация", key: "location", width: 20 },
          { header: "Тип деятельности", key: "typeActivity", width: 20 },
          { header: "Тип документа", key: "documentType", width: 20 },
          { header: "Ответственный", key: "responsible", width: 20 },
          {
            header: "Заинтересованные лица",
            key: "interestedParties",
            width: 20,
          },
          { header: "Дата начала действия", key: "startDate", width: 15 },
          {
            header: "Дата окончания действия",
            key: "expirationDate",
            width: 15,
          },
          { header: "Срок действия, лет", key: "validityPeriod", width: 15 },
          { header: "Название документа", key: "nameDocument", width: 30 },
          { header: "Детальное описание", key: "description", width: 40 },
          { header: "Гос. орган", key: "governmentAgency", width: 20 },
          { header: "Продукция", key: "products", width: 20 },
          { header: "НД", key: "nd", width: 20 },
          { header: "Код ТН ВЭД", key: "tnVedCode", width: 20 },
          { header: "Код OKPD", key: "okpdCode", width: 20 },
          {
            header: "Код вида алкогольной продукции",
            key: "codeTypeAlcoholicBeverages",
            width: 20,
          },
          {
            header: "Орган по сертификации",
            key: "certificationBody",
            width: 20,
          },
          { header: "ГТД на образцы", key: "GTD_samples", width: 20 },
          {
            header: "Передача декларации брокерам (таможенный отдел)",
            key: "transferDeclarationBroker",
            width: 20,
          },
          { header: "Статус действий", key: "actionStatus", width: 15 },
          { header: "Дата создания действия", key: "created", width: 15 },
          { header: "Описание действия", key: "descriptionAction", width: 30 },
          { header: "Совещание действия", key: "meeting", width: 30 },
          { header: "Срок выполнения действия", key: "dateForDone", width: 15 },
          { header: "Статус действия", key: "statusAction", width: 15 },
          {
            header: "Ответственный за действие",
            key: "responsibleAction",
            width: 20,
          },
          { header: "Дата обновления", key: "dateUpdate", width: 15 },
          {
            header:
              "Необходимо периодическое уведомление после даты обновления?",
            key: "periodicNotificationUpdateDate",
            width: 30,
          },
          {
            header: "Периодичность повторных уведомлений в днях",
            key: "frequencyRepeatedNotifications",
            width: 20,
          },
          { header: "Комментарий", key: "comment", width: 40 },
        ];

        data.forEach((item) => {
          const documentNumberWithLink = item.id
            ? createHyperlink(item.id, item.documentNumber || "", true)
            : item.documentNumber || "";

          //! Если есть действия, создаем строку для каждого действия
          if (item.actions && item.actions.length > 0) {
            item.actions.forEach((action: any) => {
              sheet.addRow({
                documentNumber: documentNumberWithLink,
                status: item.status?.name || "",
                location: item.location?.name || "",
                typeActivity: item.typeActivity?.name || "",
                documentType: item.documentType?.name || "",
                responsible: item.responsible?.title || "",
                interestedParties: Array.isArray(item.interestedParties)
                  ? item.interestedParties.map((p: any) => p.title).join(", ")
                  : item.interestedParties || "",
                startDate: toUTCDate(item.startDateDocument?.startDate),
                expirationDate: toUTCDate(
                  item.expirationDateDocument?.startDate
                ),
                validityPeriod: item.validityPeriodDocument || "",
                nameDocument: item.nameDocument || "",
                description: item.detailedDescription || "",
                governmentAgency: item.governmentAgency?.name || "",
                products: item.products || "",
                nd: item.ND || "",
                tnVedCode: item.code_TN_VED || "",
                okpdCode: item.code_OKPD || "",
                codeTypeAlcoholicBeverages:
                  item.codeTypeAlcoholicBeverages || "",
                certificationBody: item.certificationBody || "",
                GTD_samples: item.GTD_samples || "",
                transferDeclarationBroker: item.transferDeclarationBroker || "",
                actionStatus: item.actionStatus || "",
                created: toUTCDate(action.created),
                descriptionAction: action.description || "",
                meeting: action.meeting ? action.meeting.Title || "" : "",
                dateForDone: toUTCDate(action.dateForDone),
                statusAction: action.statusAction
                  ? action.statusAction.Title || ""
                  : "",
                responsibleAction: action.responsibleAction
                  ? action.responsibleAction.Name || ""
                  : "",
                dateUpdate: toUTCDate(item.dateUpdate?.startDate),
                periodicNotificationUpdateDate:
                  item.periodicNotificationUpdateDate?.name || "",
                frequencyRepeatedNotifications:
                  item.frequencyRepeatedNotifications || "",
                comment: item.comment || "",
              });
            });
          } else {
            //! Если нет действий, создаем одну строку без данных по действиям
            sheet.addRow({
              documentNumber: documentNumberWithLink,
              status: item.status?.name || "",
              location: item.location?.name || "",
              typeActivity: item.typeActivity?.name || "",
              documentType: item.documentType?.name || "",
              responsible: item.responsible?.title || "",
              interestedParties: Array.isArray(item.interestedParties)
                ? item.interestedParties.map((p: any) => p.title).join(", ")
                : item.interestedParties || "",
              startDate: toUTCDate(item.startDateDocument?.startDate),
              expirationDate: toUTCDate(item.expirationDateDocument?.startDate),
              validityPeriod: item.validityPeriodDocument || "",
              nameDocument: item.nameDocument || "",
              description: item.detailedDescription || "",
              governmentAgency: item.governmentAgency?.name || "",
              products: item.products || "",
              nd: item.ND || "",
              tnVedCode: item.code_TN_VED || "",
              okpdCode: item.code_OKPD || "",
              codeTypeAlcoholicBeverages: item.codeTypeAlcoholicBeverages || "",
              certificationBody: item.certificationBody || "",
              GTD_samples: item.GTD_samples || "",
              transferDeclarationBroker: item.transferDeclarationBroker || "",
              actionStatus: item.actionStatus || "",
              created: "",
              descriptionAction: "",
              meeting: "",
              dateForDone: "",
              statusAction: "",
              responsibleAction: "",
              dateUpdate: toUTCDate(item.dateUpdate?.startDate),
              periodicNotificationUpdateDate:
                item.periodicNotificationUpdateDate?.name || "",
              frequencyRepeatedNotifications:
                item.frequencyRepeatedNotifications || "",
              comment: item.comment || "",
            });
          }
        });
      } else {
        sheet.columns = [
          { header: "Номер предписания", key: "prescriptionNumber", width: 20 },
          { header: "Статус", key: "status", width: 15 },
          { header: "Локация", key: "location", width: 20 },
          { header: "Направление", key: "direction", width: 20 },
          {
            header: "Дата проведения проверки",
            key: "dateVerification",
            width: 15,
          },
          { header: "Ответственный", key: "responsible", width: 20 },
          {
            header: "Срок исполнения по предписанию",
            key: "deadline",
            width: 15,
          },
          {
            header: "Фактическая дата закрытия",
            key: "actualClosingDate",
            width: 15,
          },
          {
            header: "Госучреждение, проводившее проверку",
            key: "agencyInspection",
            width: 20,
          },
          {
            header: "Область проверки, инспектор",
            key: "scopeVerification",
            width: 20,
          },
          { header: "Цель, тип проверки", key: "typeVerification", width: 20 },
          { header: "Сфера деятельности", key: "fieldActivity", width: 20 },
          {
            header: "Подразделения, в которых проводилась проверка",
            key: "departmentsAudit",
            width: 20,
          },
          {
            header:
              "Наименование нормативного документа и номер пункта, требования которого нарушены",
            key: "nameRegulatoryDocument",
            width: 30,
          },
          {
            header: "Заинтересованные лица",
            key: "interestedParties",
            width: 30,
          },
          { header: "Статус действий", key: "actionStatus", width: 15 },
          { header: "Нарушение", key: "violations", width: 30 },
          { header: "Дата создания действия", key: "created", width: 15 },
          { header: "Описание действия", key: "description", width: 30 },
          { header: "Совещание действия", key: "meeting", width: 30 },
          { header: "Срок выполнения действия", key: "dateForDone", width: 15 },
          { header: "Статус действия", key: "statusAction", width: 15 },
          {
            header: "Ответственный за действие",
            key: "responsibleAction",
            width: 20,
          },
          { header: "Дата обновления", key: "dateUpdate", width: 15 },
          {
            header:
              "Необходимо периодическое уведомление после даты обновления?",
            key: "periodicNotificationUpdateDate",
            width: 30,
          },
          {
            header: "Периодичность повторных уведомлений в днях",
            key: "frequencyRepeatedNotifications",
            width: 20,
          },
          { header: "Размер штрафа", key: "amountFine", width: 15 },
          {
            header: "Необходимые средства на устранение замечаний",
            key: "fundsEliminationComments",
            width: 30,
          },
          { header: "Комментарий", key: "comment", width: 40 },
        ];

        const extractTextFromHtml = (html: any) => {
          if (!html) return "";
          const temp = document.createElement("div");
          temp.innerHTML = html;
          return temp.textContent || temp.innerText || "";
        };

        data.forEach((item) => {
          const prescriptionNumberWithLink = item.id
            ? createHyperlink(item.id, item.prescriptionNumber || "", false)
            : item.prescriptionNumber || "";

          //! Для каждого нарушения
          if (item.violations && item.violations.length > 0) {
            item.violations.forEach((violation: any) => {
              //! Для каждого действия в нарушении
              if (violation.actions && violation.actions.length > 0) {
                violation.actions.forEach((action: any) => {
                  sheet.addRow({
                    prescriptionNumber: prescriptionNumberWithLink,
                    status: item.status?.name || "",
                    location: item.location?.name || "",
                    direction: item.direction?.name || "",
                    dateVerification: toUTCDate(
                      item.dateVerification?.startDate
                    ),
                    responsible: item.responsible?.title || "",
                    deadline: toUTCDate(item.deadlineExecutionOrder?.startDate),
                    actualClosingDate: toUTCDate(
                      item.actualClosingDatePrescription?.startDate
                    ),
                    agencyInspection: item.agencyInspection || "",
                    scopeVerification: item.scopeVerification || "",
                    typeVerification: item.typeVerification || "",
                    fieldActivity: item.fieldActivity || "",
                    departmentsAudit: item.departmentsAudit || "",
                    nameRegulatoryDocument: item.nameRegulatoryDocument || "",
                    interestedParties: Array.isArray(item.interestedParties)
                      ? item.interestedParties
                          .map((p: any) => p.title)
                          .join(", ")
                      : item.interestedParties || "",
                    actionStatus: item.actionStatus || "",
                    violations: violation.text || "",
                    created: toUTCDate(action.Created),
                    description: action.Description || "",
                    meeting: action.Meeting ? action.Meeting.Title || "" : "",
                    dateForDone: toUTCDate(action.DateForDone),
                    statusAction: action.Status
                      ? action.Status.Title || ""
                      : "",
                    responsibleAction: action.Responsible
                      ? action.Responsible.Name || ""
                      : "",
                    dateUpdate: toUTCDate(item.dateUpdate?.startDate),
                    periodicNotificationUpdateDate:
                      item.periodicNotificationUpdateDate?.name || "",
                    frequencyRepeatedNotifications:
                      item.frequencyRepeatedNotifications || "",
                    amountFine: item.amountFine || "",
                    fundsEliminationComments:
                      item.fundsEliminationComments || "",
                    comment: extractTextFromHtml(item.comment) || "",
                  });
                });
              } else {
                //! Если в нарушении нет действий
                sheet.addRow({
                  prescriptionNumber: prescriptionNumberWithLink,
                  status: item.status?.name || "",
                  location: item.location?.name || "",
                  direction: item.direction?.name || "",
                  dateVerification: toUTCDate(item.dateVerification?.startDate),
                  responsible: item.responsible?.title || "",
                  deadline: toUTCDate(item.deadlineExecutionOrder?.startDate),
                  actualClosingDate: toUTCDate(
                    item.actualClosingDatePrescription?.startDate
                  ),
                  agencyInspection: item.agencyInspection || "",
                  scopeVerification: item.scopeVerification || "",
                  typeVerification: item.typeVerification || "",
                  fieldActivity: item.fieldActivity || "",
                  departmentsAudit: item.departmentsAudit || "",
                  nameRegulatoryDocument: item.nameRegulatoryDocument || "",
                  interestedParties: Array.isArray(item.interestedParties)
                    ? item.interestedParties.map((p: any) => p.title).join(", ")
                    : item.interestedParties || "",
                  actionStatus: item.actionStatus || "",
                  violations: violation.text || "",
                  created: "",
                  description: "",
                  meeting: "",
                  dateForDone: "",
                  statusAction: "",
                  responsibleAction: "",
                  dateUpdate: toUTCDate(item.dateUpdate?.startDate),
                  periodicNotificationUpdateDate:
                    item.periodicNotificationUpdateDate?.name || "",
                  frequencyRepeatedNotifications:
                    item.frequencyRepeatedNotifications || "",
                  amountFine: item.amountFine || "",
                  fundsEliminationComments: item.fundsEliminationComments || "",
                  comment: extractTextFromHtml(item.comment) || "",
                });
              }
            });
          } else {
            //! Если нет нарушений, создаем одну строку без данных по нарушениям и действиям
            sheet.addRow({
              prescriptionNumber: prescriptionNumberWithLink,
              status: item.status?.name || "",
              location: item.location?.name || "",
              direction: item.direction?.name || "",
              dateVerification: toUTCDate(item.dateVerification?.startDate),
              responsible: item.responsible?.title || "",
              deadline: toUTCDate(item.deadlineExecutionOrder?.startDate),
              actualClosingDate: toUTCDate(
                item.actualClosingDatePrescription?.startDate
              ),
              agencyInspection: item.agencyInspection || "",
              scopeVerification: item.scopeVerification || "",
              typeVerification: item.typeVerification || "",
              fieldActivity: item.fieldActivity || "",
              departmentsAudit: item.departmentsAudit || "",
              nameRegulatoryDocument: item.nameRegulatoryDocument || "",
              interestedParties: Array.isArray(item.interestedParties)
                ? item.interestedParties.map((p: any) => p.title).join(", ")
                : item.interestedParties || "",
              actionStatus: item.actionStatus || "",
              violations: "",
              created: "",
              description: "",
              meeting: "",
              dateForDone: "",
              statusAction: "",
              responsibleAction: "",
              dateUpdate: toUTCDate(item.dateUpdate?.startDate),
              periodicNotificationUpdateDate:
                item.periodicNotificationUpdateDate?.name || "",
              frequencyRepeatedNotifications:
                item.frequencyRepeatedNotifications || "",
              amountFine: item.amountFine || "",
              fundsEliminationComments: item.fundsEliminationComments || "",
              comment: extractTextFromHtml(item.comment) || "",
            });
          }
        });
      }
      sheet.getRow(1).font = {
        size: 12,
        bold: true,
        color: { argb: "000000" },
      };

      sheet.eachRow((row, rowNumber) => {
        row.eachCell((cell, colNumber) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };

          if (rowNumber > 1) {
            cell.font = {
              italic: true,
              size: 11,
            };

            if (
              colNumber === 1 &&
              cell.value &&
              typeof cell.value === "object" &&
              cell.value.hyperlink
            ) {
              cell.font = {
                ...cell.font,
                color: { argb: "0563C1" },
                underline: true,
              };
            }
          }

          cell.alignment = {
            vertical: "middle",
            horizontal: "left",
            wrapText: true,
          };
        });
      });

      sheet.columns.forEach((column) => {
        if (column.header) {
          column.width = (column.width as number) + 2;
        }
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", isExportLic ? "Лицензии" : "Предписания");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Ошибка при экспорте файла:", error);
    }
  };

  return (
    <div>
      <TGButton
        onClick={exportExcelFile}
        color="white"
        disabled={!data || data.length === 0}
      >
        <DownloadIcon />
      </TGButton>
    </div>
  );
};
export default ExportDataGos;
